import theme from 'config/theme';

export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: '12px',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    color: theme.palette.grays.gray600,
    fontSize: '0.75rem',
    border: `1px solid ${theme.palette.grays.gray100}`,
    borderRadius: '8px',
    justifyContent: 'space-between',
    boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.12)',
    marginBottom: '20px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flexGrow: 1,
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    a: {
      color: theme.palette.blues.primaryBlue500,
    },
  },
  detailsRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    color: theme.palette.grays.gray600,
    fontSize: '0.75rem',
  },
  title: {
    fontWeight: 600,
    color: theme.palette.grays.gray700,
    fontSize: '1rem',
    marginBottom: '12px',
  },
  vehicleName: {
    fontWeight: 700,
    color: theme.palette.grays.gray800,
    fontSize: '0.875rem',
    width: '170px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
  },
  statusBadge: (statusColor) => ({
    display: 'flex',
    alignItems: 'baseline',
    gap: '6px',
    padding: '4px 8px',
    borderRadius: '16px',
    fontSize: '0.75rem',
    fontWeight: 500,
    border: `1px solid ${statusColor.border}`,
    backgroundColor: 'white',
  }),
  statusDot: (statusColor) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: statusColor.dot,
  }),
  statusText: (statusColor) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 8px',
    borderRadius: '32px',
    border: `1px solid ${statusColor.border}`,
    backgroundColor: 'white',
    flexShrink: 0,
  }),
  closeButton: {
    alignSelf: 'anchor-center',
  },
};
